import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";


import { useAddVehicleFuelMutation } from "store/services/vehicleFuelApi";

import { useAppMeta } from "hooks";
import VehicleFuelForm from "./VehicleFuelComponents/VehicleFuelForm";

const VehicleFuelCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vehicle Fuel", path: "/app/crm/vehicle-fuel/list" },
    { title: "New Vehicle Fuel" },
  ];

  // RTK Query
  const [createVehicleFuel, { isLoading: creatingVehicleFuel }] = useAddVehicleFuelMutation();

  // Method
  const handleCreateVehicleFuel = async (data) => {
    try {
      const { _id } = await createVehicleFuel(data).unwrap();
      toast.success("Vehicle Fuel is Created!");
      navigate(`/app/crm/vehicle-fuel/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Create Vehicle Fuel!"
      );
    }
  };

  useAppMeta("New Vehicle Fuel");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingVehicleFuel}>
      <BreadcrumbLayout.Paper>
        <VehicleFuelForm isBusy={creatingVehicleFuel} onSubmit={handleCreateVehicleFuel} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleFuelCreateScreen;